import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { DeliveryDevices } from 'app/dtos/device/deliveryDeivce';
import { CreateDevice } from 'app/dtos/device/createDevice';
import { UpdateDevice } from 'app/dtos/device/updateDevice';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  constructor(private httpClientSerivce: HttpClientService) { }

  async getAllDevices(page, size, search, companyId?: number, kindId?: number, brandModelId?: number, brandId?: number, ReferenceDeviceStatus?: boolean, isReferenceDevice?: boolean) {
    const observable: Observable<any> = this.httpClientSerivce.get({
      controller: ControllerType.Device,
      queryString: `Page=${page}&Size=${size}&search=${search}&companyId=${companyId}&kindId=${kindId}&brandModelId=${brandModelId}&brandId=${brandId}&ReferenceDeviceStatus=${ReferenceDeviceStatus}&isReferenceDevice=${isReferenceDevice}`
    });
    return await firstValueFrom(observable);
  }

  async getAllCompanyDevices(page, size, search, companyId) {
    const observable: Observable<any> = this.httpClientSerivce.get({
      controller: ControllerType.Device,
      queryString: `Page=${page}&Size=${size}&search=${search}&companyId=${companyId}`,
      action: "GetAllCompanyDevices"
    });
    return await firstValueFrom(observable);
  }

  async getByIdDevice(id) {
    const observable: Observable<any> = this.httpClientSerivce.get({
      controller: ControllerType.Device
    }, id);
    return await firstValueFrom(observable);
  }

  async getAllCalibrationHistory(id) {
    const observable: Observable<any> = this.httpClientSerivce.get({
      controller: ControllerType.Device,
      action: "GetAllCalibrationHistory"
    }, id);
    return await firstValueFrom(observable);
  }

  async createDevice(createDevices: CreateDevice[]) {
    const observable: Observable<any> = this.httpClientSerivce.post({
      controller: ControllerType.Device
    }, createDevices);
    return await firstValueFrom(observable);
  }

  async updateDevice(updateDevice: UpdateDevice) {
    const observable: Observable<any> = this.httpClientSerivce.put({
      controller: ControllerType.Device
    }, updateDevice);
    return await firstValueFrom(observable);
  }

  async deliveryDevice(deliveryDevice: DeliveryDevices) {
    const observable: Observable<any> = this.httpClientSerivce.post({
      controller: ControllerType.Device,
      action: "DeliveryDevice"
    }, deliveryDevice);
    return await firstValueFrom(observable);
  }

  async sendExpiryDeivce(mail,title,content){
    const observable:Observable<any> = this.httpClientSerivce.post({
      controller:ControllerType.Device,
      action:"SendExpiryDevice"
    },
    {
      mail:mail,
      title:title,
      content:content
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}